import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f606d5a8")

_pushScopeId("data-v-f606d5a8")
const _hoisted_1 = { class: "loading-wrapper" }
const _hoisted_2 = {
  key: 1,
  style: {"width":"100%"}
}
_popScopeId()



    
export default _defineComponent({
  expose: [],
  props: {
        loadingState: {
            type: Boolean,
            default: true,
        },
        loadingText: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: '90px'
        },
        width: {
            type: String,
            default: '100%',
        }
    },
  setup(__props) {

const props = __props
_useCssVars(_ctx => ({
  "5bde1458": (props.loadingState ? props.height : "unset"),
  "745a297a": (props.loadingState ? props.width : "unset")
}))

    
    



return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (props.loadingState)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          vertical: "",
          type: "spinner",
          color: "#1989fa"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(props.loadingText), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ]))
})
}

})